import React from 'react';
import type {
  ApplicationStatus,
  JobOpeningStatus,
  JobRequisitionStatus,
} from '../api';

const BASE = 'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium';

const REQUISITION_STYLES: Record<JobRequisitionStatus, { label: string; className: string }> = {
  rascunho: { label: 'Rascunho', className: 'bg-gray-100 text-gray-700' },
  em_aprovacao: { label: 'Em aprovação', className: 'bg-blue-100 text-blue-700' },
  devolvida: { label: 'Devolvida', className: 'bg-amber-100 text-amber-800' },
  aprovada: { label: 'Aprovada', className: 'bg-green-100 text-green-700' },
  reprovada: { label: 'Reprovada', className: 'bg-red-100 text-red-700' },
  cancelada: { label: 'Cancelada', className: 'bg-gray-200 text-gray-600' },
};

const OPENING_STYLES: Record<JobOpeningStatus, { label: string; className: string }> = {
  nao_publicada: { label: 'Não publicada', className: 'bg-gray-100 text-gray-700' },
  publicada: { label: 'Publicada', className: 'bg-green-100 text-green-700' },
  despublicada: { label: 'Despublicada', className: 'bg-amber-100 text-amber-800' },
  preenchida: { label: 'Preenchida', className: 'bg-blue-100 text-blue-700' },
  encerrada: { label: 'Encerrada', className: 'bg-gray-200 text-gray-600' },
};

const APPLICATION_STYLES: Record<ApplicationStatus, { label: string; className: string }> = {
  em_analise: { label: 'Em análise', className: 'bg-blue-100 text-blue-700' },
  entrevista_agendada: { label: 'Entrevista agendada', className: 'bg-indigo-100 text-indigo-700' },
  aprovado: { label: 'Aprovado', className: 'bg-green-100 text-green-700' },
  reprovado: { label: 'Reprovado', className: 'bg-red-100 text-red-700' },
  banco_talentos: { label: 'Banco de talentos', className: 'bg-purple-100 text-purple-700' },
};

export function RequisicaoStatusBadge({ status }: { status: JobRequisitionStatus }) {
  const style = REQUISITION_STYLES[status];
  return <span className={`${BASE} ${style.className}`}>{style.label}</span>;
}

export function VagaStatusBadge({ status }: { status: JobOpeningStatus }) {
  const style = OPENING_STYLES[status];
  return <span className={`${BASE} ${style.className}`}>{style.label}</span>;
}

export function CandidaturaStatusBadge({ status }: { status: ApplicationStatus }) {
  const style = APPLICATION_STYLES[status];
  return <span className={`${BASE} ${style.className}`}>{style.label}</span>;
}

/** Devolvida mais de uma vez é sinal de atrito no fluxo — fica visível. */
export function DevolucoesBadge({ count }: { count: number }) {
  if (count <= 0) return null;
  return (
    <span className={`${BASE} bg-amber-50 text-amber-700`}>
      {count === 1 ? '1 devolução' : `${count} devoluções`}
    </span>
  );
}
